/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const GET_REBATE_PROGRAM_ADJUSTMENT_REASON_CODE =
  'GET_REBATE_PROGRAM_ADJUSTMENT_REASON_CODE';
export const SET_SELECTED_INPUT_ADJUSTMENT_REASON_CODE =
  'SET_SELECTED_INPUT_ADJUSTMENT_REASON_CODE';
export const IS_LOADING_ADJUSTMENT_REASON_CODE =
  'IS_LOADING_ADJUSTMENT_REASON_CODE';
export const REFRESH_ADJUSTMENY_CODE_REASON = 'REFRESH_ADJUSTMENY_CODE_REASON';
export const GET_ALL_ADJUSTMENT_GRID = 'GET_ALL_ADJUSTMENT_GRID';
export const GET_ADJUSTMENT_REASON_CODE_SEARCH_RESULT =
  'GET_ADJUSTMENT_REASON_CODE_SEARCH_RESULT';
export const SET_EXPORT_ALL_PDF_ADJUSTMENT_REASON_CODE =
  'SET_EXPORT_ALL_PDF_ADJUSTMENT_REASON_CODE';
export const SET_PAGINATION_INDEX_ADJUTMENT_BY_REASON_CODE =
  'SET_PAGINATION_INDEX_ADJUTMENT_BY_REASON_CODE';
export const SET_REFRESH_DATA_REDUX_DETAIL_SCREEN =
  'SET_REFRESH_DATA_REDUX_DETAIL_SCREEN';
